import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { CONTACT, FOOTER, FOOTER_LINKS } from "../../data/content";

const Footer = () => {
  return (
    <footer className={"site-footer"}>
      <span className={"orange-rule"} />
      <div className={"footer-inner container"}>
        <nav
          className={"footer-nav"}
          aria-label={"Footer"}
        >
          <ul>
            {FOOTER_LINKS.map((link) => (
              <li key={link.label}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className={"footer-contact"}>
          <img
            className={"footer-logo"}
            src={"/images/logo-white.png"}
            alt={"Alman’s Dried Fruit & Nuts"}
            width={"170"}
            height={"148"}
            loading={"lazy"}
          />
          <p>
            Tel:
            {" "}
            <a href={CONTACT.phones[0].href}>{CONTACT.phones[0].display}</a>
            <br />
            <a href={CONTACT.phones[1].href}>{CONTACT.phones[1].display}</a>
            <br />
            Email:
            {" "}
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
          </p>
          <p>
            Address:
            {" "}
            <a
              href={CONTACT.mapUrl}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              {CONTACT.address}
            </a>
          </p>
        </div>
      </div>

      <p className={"footer-copyright"}>
        {FOOTER.copyright}
        {" "}
        Proudly created by
        {" "}
        <a
          href={"https://www.tap-x.com/"}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          TapX.
        </a>
      </p>
    </footer>
  );
};

export default Footer;
